module.exports = __webpack_public_path__ + "static/media/dudun.0109dcd1.mp3";